import { PowerBiReport } from './models/power-bi-report.model';

export interface PowerBiState {
    pending: {
        reload?: boolean;
    };
    powerBiReports?: PowerBiReport[];
}

export const defaultState = (): PowerBiState => ({
    pending: {},
});
